/**
 * HSharingWidget
 *
 * Example:
 * <h-sharing-widget url="http://harri.com"
 *                   title=" Mean While in a Parallel Universe "
 *                   theme="sharing-widget"></h-sharing-widget>
 *
 * Required
 * - title: the title of what you want to share.
 *
 * Optional
 * - url: the dynamic sharing url abs or relative path, default value: page url.
 * - theme: your sharing theme, default value:sharing-widget.
 * - email-icon default value: fa-envelope-square
 * - pinterest-icon default value: fa-pinterest-square
 * - twitter-icon default value: twitter-square
 * - facebook-icon default value: fa-facebook-square
 * - linked-in-icon default value: fa-linkedin-square
 */
angular.module('harriApp')
    .directive('hSharingWidget', ['$state', '$sce', '$timeout', '$filter', 'hEvent', 'SharingWidgetService', function ($state, $sce, $timeout, $filter, hEvent, SharingWidgetService) {
        return {
            restrict: 'E',
            templateUrl: '../modules/forms/components/SharingWidget/SharingWidget.ng.html',
            scope: {
                url: '@?',
                title: '@',
                theme: '@?',
                sizing: '@?',
                templateName: '@?',
                emailIcon: '@?',
                pinterestIcon: '@?',
                hidePinterest: '<',
                twitterIcon: '@?',
                facebookIcon: '@?',
                linkedInIcon: '@?',
                whatsappIcon: '@?',
                showWhatsapp: '@?',
                hclass: '@?',
                emailIconTitle: '@?',
                pinterestUrl: '@?',
                text: '@?',
                data: '=',
                onShare: '=',
                emailSubject: '@',
                emailBody: '@',
                disabled: '<?',
            },
            link: function (scope, elem, attrs) {
                scope.title = $.trim(scope.title) == '' || !scope.title ? ' ' : scope.title;
                // set default values
                scope.sizing = scope.sizing || `md`;
                scope.theme = scope.theme ? scope.theme : 'sharing-widget';
                scope.icon = scope.icon ? scope.icon : 'square';
                scope.emailIcon = scope.emailIcon ? scope.emailIcon : 'fa-envelope';
                scope.pinterestIcon = scope.pinterestIcon ? scope.pinterestIcon : 'fa-pinterest';
                scope.twitterIcon = scope.twitterIcon ? scope.twitterIcon : 'twitter-regular';
                scope.facebookIcon = scope.facebookIcon ? scope.facebookIcon : 'fa-facebook';
                scope.linkedInIcon = scope.linkedInIcon ? scope.linkedInIcon : 'fa-linkedin';
                scope.whatsappIcon = scope.whatsappIcon ? scope.whatsappIcon : 'fa-whatsapp';
                scope.disabled = scope.disabled || false;

                if (scope.emailIconTitle) {
                    scope.emailIconTitle = $filter('translate')(scope.emailIconTitle);
                }
                else {
                    scope.emailIconTitle = $filter('translate')('Email');
                }

                scope.getSocialMediaUrl = function (source) {
                    if (!scope.disabled) {
                        return SharingWidgetService.getSocialMediaUrl(source, scope.url);
                    }
                };

                scope.getPinterestUrl = function () {
                    if (scope.pinterestUrl && !scope.disabled) {
                        return scope.pinterestUrl.replace(new RegExp('social', 'g'), 'pinterest');
                    }
                };

                var getEmailURL = function(){
                    var emailURL = scope.url;
                    if(emailURL && emailURL.indexOf('http') != 0){
                        /* add / to URL if not exisit */
                        if(emailURL.indexOf('/') != 0){
                            emailURL = '/'+emailURL;
                        }
                        emailURL = getBaseURL()+emailURL;
                    }

                    //encodeURI
                    return emailURL;
                };

                //Re-init the sharing URL on change
                scope.$watch('url', function (newValue, oldValue) {
                    var newUrl = newValue || getAddressLocation();
                    if (scope.emailBody && !/\.(png|jpe?g|gif|bmp|webp)$/i.test(scope.emailBody)) {
                        scope.emailBody = scope.emailBody.includes('utm_source') ?
                            scope.emailBody.replace(new RegExp('social','g'), 'email') :
                            scope.emailBody + '&' + 'utm_source=' + encodeURIComponent('email');
                    }

                    var emailBody = scope.emailBody || getEmailURL();
                    scope.emailString = 'mailto:?';
                    if (scope.emailSubject) {
                        scope.emailString += 'Subject=' + encodeURIComponent(scope.emailSubject);
                    }
                    scope.emailString += (scope.emailSubject ? '&' : '') + 'body=' + encodeURIComponent(emailBody);
                    if (scope.emailString) {
                        if (scope.emailString.includes('utm_source')) {
                            scope.emailString = scope.emailString.replace(new RegExp('social','g'), 'email');
                        } else {
                            scope.emailString += '&' + 'utm_source=' + encodeURIComponent('email');
                        }
                    }

                    if (scope.disabled) {
                        scope.emailString = "#"
                    }
                });
            }
        };
    }]);
